import { Navigate, Outlet } from "react-router-dom";
import { PATH_LOGIN } from "../constants/routes";

const ProtectedRoute = (props:any) => {
    if (props.isAuthenticated === null) return <p>Loading...</p>; 

	return props.isAuthenticated ? <Outlet /> : <Navigate to={PATH_LOGIN} />;
};

export default ProtectedRoute;
